import useGTMUtil, {
  GTMPageData,
  GTMSessionData,
  GTMActionData,
} from '../../../lib/useGTMUtil';

export default () => {
  const { postGTMData } = useGTMUtil();

  const NMTTP = 'need more time to pay';
  const pageDataNMTTP: GTMPageData = {
    pageName: NMTTP,
    siteSection: 'billing and payment',
    siteSubSection: NMTTP,
    journeyName: NMTTP,
    subJourneyName: undefined,
    pageTime: new Date().toISOString(),
  };
  const pageDataNMTTPJourney: GTMPageData = {
    ...pageDataNMTTP,
    subJourneyName: 'nmttp',
  };
  const pageDataPEJourney: GTMPageData = {
    ...pageDataNMTTP,
    subJourneyName: 'paymentExtension',
  };
  const pageDataTPAJourney: GTMPageData = {
    ...pageDataNMTTP,
    subJourneyName: 'tpa',
  };

  const gtm_Nmttp_HandleOnShowOptionsClick = () => {
    postGTMData({
      pageData: pageDataNMTTPJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'Check plan options',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'submit',
      },
    });
  };
  const gtm_PlanOptions_HandleOnSelectionOptionChange = (selection: String) => {
    postGTMData({
      pageData: pageDataNMTTPJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'form_input',
        actionLabel: selection,
        actionTime: new Date().toISOString(),
        actionElement: 'radio_button',
        actionSubType: 'click',
        actionOutcome: 'selection',
      },
    });
  };

  const gtm_PlanOptions_HandleOnSelectOptionSubmit = () => {
    postGTMData({
      pageData: pageDataNMTTPJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'submit',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'submit',
      },
    });
  };

  const gtm_TPAReviewPlan_HandleOnConfirmPlanClick = () => {
    postGTMData({
      pageData: pageDataTPAJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'confirm plan',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'submit',
      },
    });
  };

  const gtm_TPAREviewPlan_handleOnBackButtonClick = () => {
    postGTMData({
      pageData: pageDataTPAJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'back',
        actionTime: new Date().toISOString(),
        actionElement: 'link',
        actionSubType: 'click',
        actionOutcome: 'click',
      },
    });
  };

  const gtm_TPAReviewPlan_HandleOnConfirmPlanClickError = () => {
    postGTMData({
      pageData: pageDataTPAJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'confirm plan',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'failed',
      },
    });
  };

  const gtm_TPACreatePlan_HandleCreatePlanOnBackClick = () => {
    postGTMData({
      pageData: pageDataTPAJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'back',
        actionTime: new Date().toISOString(),
        actionElement: 'link',
        actionSubType: 'click',
        actionOutcome: 'click',
      },
    });
  };

  const gtm_TPAMakePayment_HandleOnPaymentConfirmation = () => {
    postGTMData({
      pageData: pageDataTPAJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'submit payment',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'submit',
      },
    });
  };

  const gtm_TPAMakePayment_HandleOnMakePaymentError = () => {
    postGTMData({
      pageData: pageDataTPAJourney,
      actionData: {
        actionLocation: 'alert',
        actionType: 'alert',
        actionLabel: 'PAYMENT_ERROR_MESSAGE',
        actionTime: new Date().toISOString(),
        actionElement: 'alert',
        actionSubType: 'alert',
        actionOutcome: 'alert',
      },
    });
  };

  const gtm_TPAMakePayment_HandleOnBackClick = () => {
    postGTMData({
      pageData: pageDataTPAJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'confirm plan',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'submit',
      },
    });
  };

  const gtm_PaymentConfirmationForm_HandleDoneMouseDown = () => {
    postGTMData({
      pageData: pageDataTPAJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'done',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'submit',
      },
    });
  };

  const gtm_TPASlider_HandleSlideChange = () => {
    postGTMData({
      pageData: pageDataTPAJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'slider',
        actionLabel: 'payment slider',
        actionTime: new Date().toISOString(),
        actionElement: 'slider',
        actionSubType: 'slider',
        actionOutcome: 'slide',
      },
    });
  };

  const gtm_PaymentConfirmationForm_HandleOnTryAgainClick = () => {
    postGTMData({
      pageData: pageDataTPAJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'try again',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'submit',
      },
    });
  };

  const gtm_TPACreatePlan_HandleOnReviewPlanClick = () => {
    postGTMData({
      pageData: pageDataTPAJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'Review Plan',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'submit',
      },
    });
  };

  const gtm_Confirm_HandleOnSubmit = () => {
    postGTMData({
      pageData: pageDataPEJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'submit',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'enrolled in payment extension',
      },
    });
  };

  const gtm_Confirm_HandleOnSubmitError = () => {
    postGTMData({
      pageData: pageDataPEJourney,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'submit',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'enrolled in payment extension failed',
      },
    });
  };

  return {
    gtm_Nmttp_HandleOnShowOptionsClick,
    gtm_PlanOptions_HandleOnSelectionOptionChange,
    gtm_PlanOptions_HandleOnSelectOptionSubmit,
    gtm_TPAReviewPlan_HandleOnConfirmPlanClick,
    gtm_TPAReviewPlan_HandleOnConfirmPlanClickError,
    gtm_TPAREviewPlan_handleOnBackButtonClick,
    gtm_TPASlider_HandleSlideChange,
    gtm_TPACreatePlan_HandleCreatePlanOnBackClick,
    gtm_TPACreatePlan_HandleOnReviewPlanClick,
    gtm_TPAMakePayment_HandleOnPaymentConfirmation,
    gtm_TPAMakePayment_HandleOnMakePaymentError,
    gtm_TPAMakePayment_HandleOnBackClick,
    gtm_PaymentConfirmationForm_HandleDoneMouseDown,
    gtm_PaymentConfirmationForm_HandleOnTryAgainClick,
    gtm_Confirm_HandleOnSubmit,
    gtm_Confirm_HandleOnSubmitError,
  };
};
